import formatNumber from 'src/utils/formatNumber'
import prettyAmount from 'src/utils/prettyAmount'

export const usd = { symbol: '$', exponent: 2, iso_code: 'USD' }

const interpolate = (message, data) => {
  if (typeof message == 'string' && typeof data == 'object')
    for (const key in data) {
      const keySearch = new RegExp(`%{${key}}`, 'g')
      const safeValue = (data[key] || '').toString().replace(/\$/g, '$$$$')
      message = message.replace(keySearch, safeValue)
    }

  return message
}

const translate = (key, data, messages) => {
  if (!messages) return
  const parts = Array.isArray(key) ? key : key.split('.')
  const message = messages[parts[0]]
  return parts.length == 1
  ? interpolate(message, data)
  : translate(parts.slice(1), data, message)
}

const I18n = {
  t (key, data) { return translate(key, data, this.messages) },

  // Locale-aware plural-form picker. Hides the CLDR category
  // vocabulary (zero/one/two/few/many/other) from callers — pass a
  // base i18n key and a count, get back the translated string for
  // the right form. Falls back to `<baseKey>_other` when the
  // resolved category hasn't been translated for this locale (e.g.
  // English-like locales where every category collapses to `other`,
  // or locales we haven't yet expanded with the extra forms).
  pluralize (baseKey, count, data = {}) {
    let category = 'other'
    try {
      category = new Intl.PluralRules(this.locale || 'en').select(count)
    } catch {
      if (count === 1) category = 'one'
    }

    const interpolation = { ...data, count }
    return this.t(`${baseKey}_${category}`, interpolation) ??
      this.t(`${baseKey}_other`, interpolation)
  },

  formatNumber (amount) {
    return formatNumber(amount, this.currency || {})
  },

  formatCurrency (amount, currency = usd, alwaysDisplayFractional) {
    const amountString = alwaysDisplayFractional
    ? amount.toFixed(currency.exponent)
    : prettyAmount(amount, currency.exponent)

    // Format template precedence: the passed currency may carry its
    // own format (crypto sets "%n %c" via OrderSerializer#currency
    // because it has no Money::Currency symbol to inject). Falls back
    // to the donor's i18n.currency.format for fiat ("%u%n" for USD,
    // "%n€" for EUR, etc.), and to "%u%n" as a last resort.
    return (currency.format || this.currency.format || '%u%n')
    .replace('%u', currency.symbol || '')
    .replace('%c', currency.iso_code || '')
    .replace('%n', this.formatNumber(amountString))
    .trim()
  }
}

const createI18n = config =>
  I18n.isPrototypeOf(config) ? config :
  Object.assign(Object.create(I18n), config)

export default createI18n
